import { loadTimeForm } from 'features/daily-plan/utils';
import strings from 'strings';
import { EntityType } from 'UI/constants/entityTypes';
import { OptionRenderers } from 'UI/utils/renderers';

import { prepareDateForPicker } from '../shared/DateTimePickers/DateTimePicker.utils';

export const FORM_FIELDS_MAP = {
  TaskId: {
    key: 'id'
  },
  TaskType: {
    key: 'taskType',
    paramKey: 'taskTypeId',
    outboundAccesor: 'id'
  },
  Date: {
    key: 'date',
    inboundAccesor: form => prepareDateForPicker(form)
  },
  Time: {
    key: 'time',
    inboundAccesor: loadTimeForm
  },
  Position: {
    key: 'position',
    paramKey: 'jobOrderOfferId',
    outboundAccesor: 'id',
    inboundAccesor: 'jobOrder'
  },
  ReachToEntity: {
    key: 'reachTo',
    inboundAccesor: form =>
      form.entityType?.code === EntityType.Contact || form.entityType?.code === EntityType.Candidate
        ? EntityType.Candidate
        : null
  },
  ReachToName: {
    key: 'reachToName',
    outboundAccesor: 'id',
    inboundAccesor: form => ({
      id: form.entity?.id,
      fullName: form?.entity?.contactName,
      entityType: form.entityType?.code
    })
  },
  Comments: {
    key: 'comment',
    inboundAccesor: 'lastComment'
  }
};

export const REACH_OUT_AUTOCOMPLETE_PROPS_BY_ENTITY = {
  candidate: {
    placeholder: strings.dailyPlan.drawer.form.placeholders.selectCandidate,
    url: '/search',
    typeaheadParams: { schema: 'contactDirectory', entityTypeGroup: EntityType.Candidate },
    renderOption: OptionRenderers.globalSearchPerson('fullName'),
    displayKey: 'fullName'
  }
};

export const REACH_OUT_TO_RADIO_OPTIONS = [
  {
    id: 1,
    value: 'candidate',
    label: `${strings.dailyPlan.drawer.form.labels.candidate} / ${strings.dailyPlan.drawer.form.labels.candidateProspect}`
  }
];
